import { get, flow, values, mapValues, split } from 'lodash/fp';
import { VISIT_GROUP, CF_VISIT_GROUP } from '../../constants';

const columnsToLabel = (query, columnsByType) =>
  flow(
    mapValues(val => {
      const [type, column] = split('.', val);
      const alias = type === CF_VISIT_GROUP ? VISIT_GROUP : type;
      return get(`${alias}.${column}.label`, columnsByType);
    }),
    values
  )(query);

export default columnsToLabel;
